
















import { Component, Vue } from 'vue-property-decorator'
import * as modules from '../../../store/decorator'
import Authorize from '../../../class/authorize'

@Component({
    inject: ['$validator']
})
export default class Login extends Vue {

    loading = false
    error = false
    userDetails = {
        email: '',
        password: ''
    }
    errorMessage = "Invalid username or password";

    processForm() {
        this.loading = true

        this.$validator.validate()
            .then(async result => {

                if (!result) return this.loading = false

                this.error = false
                this.$auth.login({
                    data: {
                        encrypted_string: await new Authorize(this.$http, this.userDetails.email, this.userDetails.password).login()
                    },
                    rememberMe: true,
                    redirect: false,
                    success: async (response) => {
                        modules.user.storeSessionDetail(response.data)
                        modules.user.storeUserDetail(response.data)
                        modules.user.storeCustomerAccess(response.data)
                        modules.user.storeCustomerDetail(response.data)

                        // Fetch agreement data once and store it
                        try {
                            const agreementResponse = await this.$http.post(process.env.VUE_APP_V3_USER_GET, {
                                userid: response.data.userDetail.userId
                            }, {
                                headers: {
                                    Authorization: process.env.VUE_APP_V3_API_KEY
                                }
                            })

                            // Store agreement data in the store
                            modules.user.storeAgreementDetail(agreementResponse.data)

                            // Check if agreement is needed and redirect accordingly
                            if (!modules.user.agreementDetail.agreementAccepted) {
                                this.$router.push({ name: 'agreement' });
                            } else {
                                this.$router.push({ name: 'home' });
                            }
                        } catch (error) {
                            this.$router.push({ name: 'agreement' });
                        }
                    },
                    error: (error) => {
                        this.error = true
                        this.loading = false
                    }
                })
            })
    }
}
